import rainbowRich from './rainbowRich';

export default rainbowRich;
